<template>
  <div class="text-center text-white py-5">
    <div class="w-100 mt-3">
      <div class="">
        <div>
          <h3>{{ user.firstName }} {{ user.lastName }}</h3>
        </div>
        <div>
          <a href="#" @click.prevent="openEditModal()" class="btn btn-link text-white">
            Редактировать профиль
          </a>
        </div>
      </div>
    </div>

    <profile-edit :item="user" ref="modal" @update="update"></profile-edit>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProfileEdit from '../../Student/Includes/ProfileEditModal'

export default {
  props: {
    user: Object
  },
  components: {
    profileEdit: ProfileEdit
  },
  data () {
    return {
      show: true
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.auth.loading
    })
  },
  methods: {
    openEditModal () {
      this.$refs.modal.toggleModal()
    },
    update () {
      this.$refs.modal.hideModal()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('SET_LOADING', false)

    setTimeout(() => {
      this.show = false
    }, 2000)
    if (!this.user.onboardingComplete) {
      this.openEditModal()
    }
  },
  created () {
    this.$store.dispatch('SET_LOADING', true)
  }
}
</script>